import { AnalyticsBrowser } from "@segment/analytics-next";
import { useMemo } from "react";

import { EnvVar } from "@/env";

import { AnalyticsContext, AnalyticsContextProps } from "./context";

interface AnalyticsProviderProps {
  children: React.ReactNode;
}

export const AnalyticsProvider: React.FC<AnalyticsProviderProps> = ({ children }) => {
  // TODO: create and move to app config
  const writeKey = EnvVar.segmentWriteKey || "";

  const value: AnalyticsContextProps = useMemo(
    () => ({
      analytics: AnalyticsBrowser.load(
        {
          writeKey,
        },
        {
          integrations: {
            "Intercom Web (Actions)": false,
          },
        }
      ),
    }),
    [writeKey]
  );

  return <AnalyticsContext.Provider value={value}>{children}</AnalyticsContext.Provider>;
};
